import get from 'lodash/get'

import { executeCode, getPathString, renderJSXValueCell } from '@helpers'
import { BIND_TYPE, EXPAND_FIELD_PREFIX } from '@constants'
import { ObjectDataRecord, TimeLineDTOType } from '@types'

type Props = {
  config: TimeLineDTOType
  item: ObjectDataRecord
}

export const getColumnHeaderNameForColumnObject = (props: Props) => {
  const { config, item } = props

  if (
    config.objectX.columnsObject?.headerBindType === BIND_TYPE.FIELD &&
    config.objectX.columnsObject.headerField?.length
  ) {
    if (config.objectX.columnsObject.headerField?.length > 1) {
      const headerField = config.objectX.columnsObject.headerField

      return get(
        item,
        `${getPathString(headerField.slice(0, -1), EXPAND_FIELD_PREFIX)}.${
          headerField[headerField.length - 1].field
        }`
      )
    }

    return get(item, getPathString(config.objectX.columnsObject.headerField))
  }

  if (
    config.objectX.columnsObject?.headerBindType === BIND_TYPE.JS &&
    config.objectX?.columnsObject?.headerScript
  ) {
    return executeCode(config.objectX?.columnsObject?.headerScript, {
      srcObj: {
        item,
      },
    })
  }

  if (
    config.objectX.columnsObject?.headerBindType === BIND_TYPE.JSX &&
    config.objectX?.columnsObject?.headerScript
  ) {
    return renderJSXValueCell(config.objectX?.columnsObject?.headerScript, {
      item,
    })
  }
}
